
  var _styles = {
  "more-col-container": {
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "3.17333rem",
    "overflow": "hidden",
    "boxSizing": "border-box"
  },
  "more-col-title": {
    "marginTop": "0.13333rem"
  },
  "more-col-time": {
    "marginTop": "0.10667rem"
  }
};



  module.exports = _styles;
  